import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ButtonsModule } from "ngx-bootstrap/buttons";

import { CommonModule } from "@angular/common";

// Datepicker
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { AreaTreeComponent } from "./area-tree.component";
import { PipeModule } from "../../../pipes/pipe.module";
import { CoreTreeComponent } from "./core-tree.component";

@NgModule({
  imports: [
    FormsModule,
    NgSelectModule,
    CommonModule,
    BsDropdownModule,
    ButtonsModule.forRoot(),
    TranslateModule,
    PipeModule,
  ],
  exports: [AreaTreeComponent, CoreTreeComponent],
  declarations: [AreaTreeComponent, CoreTreeComponent],
})
export class AreaTreeModule {}
